import { PlayCircleOutlined, HomeOutlined } from '@ant-design/icons'
import { displayMessage } from '../../services/helper'

export const sideMenuItensIconsStyle = {
  fontSize: 20
}

export default
  {
    patientMenuItems: [
      {
        key: "/patient-home",
        icon: <HomeOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('HOME_TITLE'),
      },
      {
        key: "monitory-tutorials",
        icon: <PlayCircleOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('MONITORY_TUTORIAL_TITLE_MENU'),
      },
      {
        key: "exercises-tutorials",
        icon: <PlayCircleOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('EXERCISES_TUTORIAL_TITLE_MENU'),
      },
    ],
  }